import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {handleFooterLinks} from "./helpers";
import {isEmpty} from "@helpers/helpers";
import LinkList from "@atoms/link_lists";
import Divider from "@atoms/divider";
import Icon from "@atoms/icon";
import {Round} from "../../helpers/numbers";
import {array_chunk} from "../../helpers/arrays";
import InstagramIcon from "@icons/instagram.svg";
import {getDefaultCity} from "../../hooks/cities";

function Footer({page, footerLinks, selectedCityId, propertyDealType}) {

    const [specialLinksState, setSpecialLinks] = useState({
        links: [],
        title: 'لینک‌های منتخب'
    });
    const [otherPagesState, setOtherPages] = useState([]);
    const [beforeFooterSectionLinksState, setBeforeFooterSectionLinks] = useState([]);

    useEffect(() => {
        const city_id = !isEmpty(selectedCityId) ? selectedCityId : getDefaultCity();

        if (isEmpty(footerLinks) || (Number(city_id))) {

            handleFooterLinks(city_id, propertyDealType, page).then(result => {
                if (!isEmpty(footerLinks)) {
                    footerLinks['otherPagesLinks'] = null;
                    footerLinks['specialLinks'] = null;
                    footerLinks['beforeFooterSectionLinks'] = null;
                }

                const {otherPagesLinks, specialLinks, beforeFooterSectionLinks} = result;

                setOtherPages(otherPagesLinks);

                setSpecialLinks(specialLinks);

                setBeforeFooterSectionLinks(beforeFooterSectionLinks);
            })
        }
    }, [selectedCityId, footerLinks,propertyDealType]);

    const otherPages = (otherPagesState.length) ? otherPagesState : ((footerLinks && !isEmpty(footerLinks['otherPagesLinks'])) ? footerLinks['otherPagesLinks'] : []);
    const specialCities = (specialLinksState.links.length) ? specialLinksState : ((footerLinks && !isEmpty(footerLinks['specialLinks'])) ? footerLinks['specialLinks'] : specialLinksState);
    const beforeFooterSectionLinks = (beforeFooterSectionLinksState.length) ? beforeFooterSectionLinksState : ((footerLinks && !isEmpty(footerLinks['beforeFooterSectionLinks'])) ? footerLinks['beforeFooterSectionLinks'] : beforeFooterSectionLinksState);
    const beforeFooterSectionLinksChunk = (beforeFooterSectionLinks.length) ? Round(beforeFooterSectionLinks.length / 4) : 0;


    return (
        <Container>

            {
                (beforeFooterSectionLinks.length > 0) ?
                    <div className="container sm-fluid">
                        <div className="row before-footer-section-links">
                            {
                                array_chunk(beforeFooterSectionLinks, beforeFooterSectionLinksChunk).map((chunkItems, key) =>
                                    <div className="col-3 footer-column" key={key}>
                                        <LinkList items={chunkItems}/>
                                    </div>
                                )
                            }
                        </div>

                        <Divider className="mt-40 mt-lg-32 mb-48 mb-lg-40 footer-divider"/>
                    </div>
                    : ''
            }

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 pl-md-32">
                        <BrandLogo className="mb-16">
                            <img src="/_img/rgb-logo.svg" className="img-cover" alt="2nabsh logo"/>
                        </BrandLogo>
                        <span className="d-block font-weight-bold mb-8 ">راهی سریع و مطمئن برای خانه‌دار شدن</span>
                        <p className="font-weight-light pl-0 pl-md-40">
                            در ۲نبش بین صدها هزار آگهی ثبت‌شده جست‌وجو کنید، به سرعت ملک مورد نظرتون رو پیدا کنید و برای انجام معامله‌ای مطمئن، با مشاورین املاک معتمد و متخصص شهرتون در ارتباط باشید.
                        </p>

                        <div className="d-flex justify-content-center justify-content-lg-start mt-48">
                            <Enamad>
                                <img src="/_img/samandehi.jfif" className="img-fluid" alt=""/>
                            </Enamad>

                            <Enamad className="mr-16">
                                <script src="https://www.zarinpal.com/webservice/TrustCode" type="text/javascript"></script>
                            </Enamad>

                            {/*<Enamad className="mr-16">
                                <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=146529&amp;Code=7zibluMqlPUGpobVY1gS">
                                    <img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=146529&amp;Code=7zibluMqlPUGpobVY1gS" className="img-fluid" alt="نماد اعتماد الکترونیکی" id="7zibluMqlPUGpobVY1gS" />
                                </a>
                            </Enamad>*/}
                        </div>
                    </div>

                    <div className="footer-column col-6 col-md-3 mt-48 mt-md-0 ">
                        <span className="d-block h4 mb-16">همراه با ۲نبش</span>

                        <LinkList items={otherPages}/>
                    </div>

                    <div className="footer-column col-6 col-md-3 mt-48 mt-md-0">
                        <span className="d-block h4 mb-16">{specialCities.title}</span>
                        <LinkList items={specialCities.links}/>
                    </div>
                </div>

                <Divider className="m-0 mt-48 mt-lg-40 footer-divider"/>

                <div className="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center justify-content-lg-between">
                    <a rel="noopener" href="https://www.instagram.com/2nabsh_com" target="_blank" className="d-flex align-items-center instagram-button btn btn-sm btn-outline-dark mt-24 mt-lg-0">
                        <Icon width="18" height="18">
                            <InstagramIcon/>
                        </Icon>
                        <span className="h4-normal mr-8">اینستاگرام ۲نبش</span>
                    </a>

                    <div className="my-24 text-md-right d-flex align-items-center">
                        <span className="ml-8">&copy;</span>
                        <span> 2نبش 1401</span>
                        <span className="mx-8">|</span>
                        <span>فناوران پیشتاز مسکن فردا</span>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default React.memo(Footer);

// styles

const Container = styled.div`
  .footer-divider {
     border-color: #dddddd !important;
  }

  background-color: ${props => props.theme.gray100};

  padding-top: 72px;
  
  @media (max-width: ${props => props.theme.screenSmMax}) {
     padding-top: 40px;
     
     .before-footer-section-links {
        display: flex;
        overflow-x: auto;
        flex-wrap: nowrap;
        margin: 0;
        
        .footer-column {
            flex: 0 0 auto;
            width: 67%;
            max-width: 67%;
            padding: 0;
            
            &:first-child {
                margin-right: 24px;
            }
            
            &:last-child {
                margin-left: 24px;
            }
            
            ul {
                white-space: normal;
            }
        }
     }
  }

  .instagram-button {
    border-width: 1.6px;
    overflow: hidden;
    position: relative;

    span {
      z-index: 3;
    }

    .icons {
      z-index: 3;

      svg {
        g {
          rect {
            stroke-width: 1.5px;
          }

          path {
            stroke-width: 1.5px;
          }
        }
      }
    }

    &:hover {
      background: linear-gradient(90deg, #fd1d1d, #833ab4);
      border: solid 1.6px transparent;
      border-left-color: #fd1d1d;
      border-right-color: #833ab4;
      color: #fff;
      transition: 0s all ease;

      .icons {
        svg {
          g {
            rect {
              stroke: #fff;
            }

            path {
              stroke: #fff;
            }
          }
        }
      }
    }
  }

  .footer-column {
    li {
      margin-bottom: 8px;
      font-weight: 300;
    }
  }
`;

const BrandLogo = styled.div`
  width: 92px;
  height: auto;

  @media (max-width: ${props => props.theme.screenSmMax}) {

  }
`;

const Enamad = styled.div`
  img {
    mix-blend-mode: multiply;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
  }

  width: 96px;
`;